import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The TradedAmounts's component.
 */
const TradedAmountsByYears = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-MontosTransados.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar. Con un máximo de 4 años al mismo tiempo.</Item>
        <Item>
          Selecciona el tipo de distribución que deseas para los datos, puedes ver el monto transado en cada mes o su
          acumulativo anual.
        </Item>
        <Item>Selecciona el tipo de moneda para los datos, puede ser peso chileno o dólar estadounidense.</Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Eje correspondiente a los montos transados en millones de pesos.</Item>
        <Item>Eje correspondiente a todos los meses del año.</Item>
        <Item>Leyenda para el o los meses consultados.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default TradedAmountsByYears
